import {ControlledSelect} from '@hm/fundamental'

import {useRiskSurveyTranslation} from '../../hooks'
import {RiaPriority, RiaStatus} from '../../types'

type RiaFiltersProps = {
  statusFilter: RiaStatus[]
  onStatusFilterChange: (values: RiaStatus[]) => void
  priorityFilter: RiaPriority[]
  onPriorityFilterChange: (values: RiaPriority[]) => void
}

export const RiaFilters = ({
  statusFilter,
  onStatusFilterChange,
  priorityFilter,
  onPriorityFilterChange
}: RiaFiltersProps) => {
  const {t} = useRiskSurveyTranslation()

  // Waived is excluded from the filter: it is no longer a selectable status and no
  // active RIAs use it. The enum value is retained only for historical display.
  const statusOptions = Object.values(RiaStatus)
    .filter((status) => status !== RiaStatus.Waived)
    .map((status) => ({
      value: status,
      label: t(`status.${status}`)
    }))

  const priorityOptions = Object.values(RiaPriority).map((priority) => ({
    value: priority,
    label: t(`priority.${priority}`)
  }))

  return (
    <div className="flex gap-4 flex-wrap">
      <div className="min-w-[200px]">
        <ControlledSelect
          name="riaStatusFilter"
          label={t('overview.statusFilter')}
          value={statusFilter[0] ?? ''}
          onChange={(value) => onStatusFilterChange(value ? [value as RiaStatus] : [])}
          values={[{value: '', label: t('common.all')}, ...statusOptions]}
          data-cy="ria-status-filter"
        />
      </div>
      <div className="min-w-[200px]">
        <ControlledSelect
          name="riaPriorityFilter"
          label={t('overview.priorityFilter')}
          value={priorityFilter[0] ?? ''}
          onChange={(value) => onPriorityFilterChange(value ? [value as RiaPriority] : [])}
          values={[{value: '', label: t('common.all')}, ...priorityOptions]}
          data-cy="ria-priority-filter"
        />
      </div>
    </div>
  )
}
